/* eslint-disable react/prop-types */
import Icon from 'components/icon';
import { Button } from 'react-bootstrap';

const IconButton = ({ icon, iconProp, style, ...props }) => {
  return (
    <Button
      style={{
        padding: '0.5rem',
        ...style
      }}
      {...props}
    >
      <Icon fontSize={'14px'} icon={icon} {...iconProp} />
    </Button>
  );
};

export default IconButton;
